import React from 'react';
import castArray from 'lodash/castArray';

export default function BuildChildren(children) {
  if (!children) {
    return null;
  } else if (React.isValidElement(children)) {
    return children;
  }

  return castArray(children).map((child, index) => {
    if (React.isValidElement(child)) {
      return child;
    }

    // Must use dynamic import to avoid circular import reference errors
    const Components = require('containers').default; // eslint-disable-line global-require

    const { type, id } = child;
    const Component = Components[type];

    if (!Component) {
      console.error(`No Component found for type '${type}'.`); // eslint-disable-line no-console
    }

    return Component && <Component key={`child-${id || index}`} {...child} />;
  });
}
